/* global localData */
function emptyEventList(currentTab) {
  // eslint-disable-next-line no-param-reassign
  currentTab.querySelector('.event-list .row').innerHTML = '';
}
function prepareRenderEventResults(page, clear, currentTab) {
  const year = currentTab.querySelector('input[name*="years"]:checked') ? currentTab.querySelector('input[name*="years"]:checked').getAttribute('id') : '';
  const type = currentTab.querySelector('input[name*="types"]:checked') ? currentTab.querySelector('input[name*="types"]:checked').getAttribute('id') : '';
  const categories = currentTab.querySelector('input[name*="categories"]:checked') ? currentTab.querySelector('input[name*="categories"]:checked').getAttribute('id') : '';
  // eslint-disable-next-line no-use-before-define
  ajaxEventCall(page, clear, year, type, categories, currentTab);
}
function initEventShowMore() {
  const showMore = document.querySelectorAll('.link--load-more');
  showMore.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const currentTab = e.target.closest('.tab-content');
      let page = 2;
      if (currentTab.dataset.page) {
        page = Number(currentTab.dataset.page);
      } else {
        currentTab.dataset.page = String(page);
      }
      // eslint-disable-next-line no-use-before-define
      prepareRenderEventResults(page, false, currentTab);
    });
  });
}
function ajaxEventCall(page, clear, year, type, categories, currentTab) {
  document.querySelector('.loading').classList.add('is-active');
  const request = new XMLHttpRequest();
  request.open('POST', localData.siteURL, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  request.send(`action=getEvents&nonce=${localData.nonce}&page=${page}&year=${year}&type=${type}&categories=${categories}&tabtype=${currentTab.dataset.tabtype}`);
  request.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      const response = JSON.parse(this.responseText);
      if (clear) {
        emptyEventList(currentTab);
      }
      if (response.data.html) {
        // eslint-disable-next-line no-param-reassign
        currentTab.querySelector('.event-list .row').innerHTML += response.data.html;
      }
      if (response.data.last) {
        // eslint-disable-next-line no-param-reassign
        currentTab.querySelector('.link--load-more').hidden = true;
      } else {
        const paged = document.querySelector('.tab-content.active').dataset.page;
        document.querySelector('.tab-content.active').dataset.page = Number(paged) + 1;
      }
      document.querySelector('.tab-nav__link.is-active').click();
    }
    setTimeout(() => {
      document.querySelector('.loading').classList.remove('is-active');
    }, 500);
  };
}
if (document.querySelector('.event-list')) {
  const newsFilterButtons = document.querySelectorAll('.dropdown-filter__list input');
  newsFilterButtons.forEach((item) => {
    item.addEventListener('change', (e) => {
      const currentTab = e.target.closest('.tab-content');
      currentTab.dataset.page = '1';
      prepareRenderEventResults(1, true, currentTab);
    });
  });
  initEventShowMore();
}
